import { visuallyHidden } from '@insify/css/classes.module.css';
import { TrackedInputCheckbox } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { forwardRef } from 'react';

import { Check } from '../../icons';

import * as styles from './Checkbox.module.css';

import type { Testid } from '../../types';
import type { TrackingProps } from '../types';
import type React from 'react';
import type { SetRequired } from 'type-fest';

export type CheckboxProps = SetRequired<Omit<React.ComponentPropsWithoutRef<'input'>, 'children' | 'type'>, 'name'> & {
  nativeInputClassName?: string;
  error?: string;
} & Partial<TrackingProps> &
  Testid;

// https://www.figma.com/file/ssGmau7DMZsdIX7F6k0lGk/%E2%9A%A1%EF%B8%8F-Design-System?type=design&node-id=45-1680&mode=design&t=ofKIuOSPHQWXBcWo-0
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, className, nativeInputClassName, 'data-testid': testId, trackingId, ...props }, ref) => {
    const idWithNameFallback = id ?? props.name;
    const trackingIdWithNameFallback = trackingId ?? props.name;
    const hasError = Boolean(props.error);
    return (
      <>
        <TrackedInputCheckbox
          ref={ref}
          objectiv={{ id: trackingIdWithNameFallback, trackValue: true }}
          className={clsx(visuallyHidden, styles.nativeCheckbox, nativeInputClassName, hasError && styles.error)}
          id={idWithNameFallback}
          {...props}
        />
        <label
          htmlFor={idWithNameFallback}
          className={clsx(styles.customCheckbox, className)}
          aria-label={idWithNameFallback}
          data-testid={testId}
        >
          <Check className={styles.checkIcon} />
        </label>
      </>
    );
  },
);
